import { useRef } from 'react'
import { useIsomorphicLayoutEffect } from '../../../core/hook/useIsomorphicLayout'
import { CustomCmsSeller } from '../../../domain/seller'
import { storeInformationGetMapEl } from './helpers'

const buildDirectionRouteGoogleMap = (
  seller: CustomCmsSeller,
  origin: { latitude: number; longitude: number },
) => {
  const urlGoogleMap = `https://www.google.com/maps/dir/?api=1&origin=${origin.latitude},${origin.longitude}&destination=${seller.latitude},${seller.longitude}`
  return urlGoogleMap
}

const buildMarkerRouteGoogleMap = (seller: CustomCmsSeller) => {
  const urlGoogleMap = `https://www.google.com/maps/dir/?api=1&destination=${seller.latitude},${seller.longitude}`
  return urlGoogleMap
}

const seeItinerary = (seller: CustomCmsSeller) => {
  navigator.geolocation.getCurrentPosition(
    (geolocationPosition) => {
      // if we have geo coordinates of user, redirect to google map with directions API
      const { latitude, longitude } = geolocationPosition.coords
      const urlGoogleMap = buildDirectionRouteGoogleMap(seller, { latitude, longitude })
      window.open(urlGoogleMap)
    },
    () => {
      // if we don't have geo coordinates of user, redirect to google map with marker of seller only
      const urlGoogleMap = buildMarkerRouteGoogleMap(seller)
      window.open(urlGoogleMap)
    },
  )
}

const initMarkerOnMap = (coords: { lat: number; lng: number }, map?: google.maps.Map) => {
  const { lat, lng } = coords

  return new google.maps.Marker({
    position: {
      lat,
      lng,
    },
    map,
    icon: '/assets/img/map/marker/marker_01.png',
  })
}

const useStoreInformationGoogleMap = (seller: CustomCmsSeller) => {
  // Google Map
  const mapRef = useRef<google.maps.Map>()
  // Marker of seller on Google Map
  const markerSellerRef = useRef<google.maps.Marker>()

  useIsomorphicLayoutEffect(() => {
    const mapEl = storeInformationGetMapEl()

    if (!mapEl) {
      return
    }

    if (!mapRef.current) {
      // Init Google Map
      mapRef.current = new google.maps.Map(mapEl, {
        center: { lat: Number(seller.latitude), lng: Number(seller.longitude) },
        zoom: 15,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      })

      // Init Marker on Google Map for Store
      markerSellerRef.current = initMarkerOnMap(
        {
          lat: Number(seller.latitude),
          lng: Number(seller.longitude),
        },
        mapRef.current,
      )
    }
  }, [seller])

  return {
    mapRef,
    seeItinerary,
    defaultIniteraryLink: buildMarkerRouteGoogleMap(seller),
  }
}

export default useStoreInformationGoogleMap
